import { configureStore, Middleware, Tuple } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import reducer from './reducer';
import rootSaga from './saga';

const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
  reducer,
  // this typecasting is needed to avoid strange type discrepancy between redux-saga and rtk
  middleware: () => new Tuple(sagaMiddleware as Middleware),
});
sagaMiddleware.run(rootSaga);
